import { render, staticRenderFns } from "./BookingSummary.vue?vue&type=template&id=5f20789c&scoped=true&"
import script from "./BookingSummary.vue?vue&type=script&lang=js&"
export * from "./BookingSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingSummary.vue?vue&type=style&index=0&id=5f20789c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20789c",
  null
  
)

export default component.exports